import React, { useEffect } from 'react';
import BrandHeader from '../brandheader/BrandHeader';
import styles from './AgentStaticTeaser.less';
import { AgentPictureWrapper } from '../agentpicture/AgentPictureWrapper';
import { isBasicBranchenbuchAgent } from '../../utils/AgentUtils';
import { PRO_MARKETEER_AGENT } from '../../models/AgentTypes';
import { trackEvent } from '../../utils/tracking';
import { useAppSelector } from '../../store/store';
export var AgentStaticTeaser = function AgentStaticTeaser() {
  var teaserData = useAppSelector(function (state) {
    return state.teaserData;
  });
  var currentPage = useAppSelector(function (state) {
    var _state$search$current;
    return (_state$search$current = state.search.currentPage) !== null && _state$search$current !== void 0 ? _state$search$current : 1;
  });
  var totalNumberOfAgents = useAppSelector(function (state) {
    return state.search.totalNumberOfAgents || 0;
  });
  var staticTeaserData = teaserData.staticTeaserData;
  if (currentPage === 1 && totalNumberOfAgents > 0 && teaserData.isLoggedIn && staticTeaserData.linkUrl) {
    var message = staticTeaserData.message,
      linkDescription = staticTeaserData.linkDescription,
      linkUrl = staticTeaserData.linkUrl;
    var company = {
      name: staticTeaserData.displayName,
      logoUrl: staticTeaserData.logoUrl,
      brandColor: staticTeaserData.brandColor,
      agentPictureUrl: staticTeaserData.agentPictureUrl
    };
    var basicAgentStyle = function basicAgentStyle(type) {
      return isBasicBranchenbuchAgent(type) ? styles.agentStaticTeaserOpacity : '';
    };
    useEffect(function () {
      trackEvent({
        label: "sov_transparency_teaser_shown",
        name: 'sov_transparency_teaser_shown'
      });
    });
    var onClick = function onClick() {
      trackEvent({
        label: "sov_transparency_teaser_clicked",
        name: 'sov_transparency_teaser_click'
      });
    };
    return /*#__PURE__*/React.createElement("a", {
      className: styles.agentStaticTeaserLink,
      href: linkUrl,
      onClick: onClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.agentListItem, " ").concat(basicAgentStyle(PRO_MARKETEER_AGENT), " padding-top-m")
    }, /*#__PURE__*/React.createElement(BrandHeader, {
      company: company
    }), /*#__PURE__*/React.createElement("div", {
      className: "margin-l background-white"
    }, /*#__PURE__*/React.createElement("div", {
      className: "one-whole grid grid-flex grid-align-start",
      style: {
        flexFlow: 'row nowrap'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-item"
    }, /*#__PURE__*/React.createElement(AgentPictureWrapper, {
      pictureUrl: teaserData.staticTeaserData.agentPictureUrl,
      isBasicBranchenbuchAgent: false,
      badges: []
    })), /*#__PURE__*/React.createElement("div", {
      className: "grid-item ".concat(styles.companyInfoWrapper)
    }, /*#__PURE__*/React.createElement("div", {
      "data-testid": "company-name",
      className: "".concat(styles.companyName, " one-whole float-left font-heading-xsmall-regular")
    }, company.name), /*#__PURE__*/React.createElement("div", {
      className: "palm-hide"
    }, /*#__PURE__*/React.createElement("div", {
      "data-testid": "message",
      className: "".concat(styles.message, " one-whole float-left padding-bottom-m font-heading-medium-regular")
    }, message), /*#__PURE__*/React.createElement("div", {
      "data-testid": "link-description",
      className: "touch-area font-body-medium-regular"
    }, /*#__PURE__*/React.createElement("span", {
      className: "is24-icon-chevron-right"
    }), " ", linkDescription)))), /*#__PURE__*/React.createElement("div", {
      className: "desk-hide lap-hide one-whole padding-top-l"
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.message, " one-whole float-left padding-bottom-m font-heading-medium-regular")
    }, message), /*#__PURE__*/React.createElement("div", {
      className: "touch-area font-body-medium-regular"
    }, /*#__PURE__*/React.createElement("span", {
      className: "is24-icon-chevron-right"
    }), " ", linkDescription)))));
  } else return /*#__PURE__*/React.createElement(React.Fragment, null, " ");
};